// Substitui o pacote `lodash.pick`, que está deprecado e carrega o alerta de
// prototype pollution do lodash antigo (GHSA-p6mc-m468-83gw).
// Todas as chamadas do projeto usam chaves planas — nenhum caminho com ponto —
// então esta implementação é equivalente à do lodash para o nosso uso.
export default function pick(obj, ...keys) {
  const flatKeys = keys.flat();

  return flatKeys.reduce((acc, key) => {
    if (obj != null && Object.prototype.hasOwnProperty.call(obj, key)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
